import { studioIsStudioAIUserQueryOptions, useStudioIsStudioAiUserQuery } from '../gen/account'
import { queryClient } from '@repo/studio-utils/query-client'
import ms from 'ms'

const options = {
  staleTime: ms('20s'),
}

export const useIsStudioAIUser = () => {
  const { data: isStudioAIUser } = useStudioIsStudioAiUserQuery(undefined, {
    ...options,
    select: data => data?.studioIsStudioAIUser?.studioAIUser,
  })
  return isStudioAIUser === true
}

export const useIsStudioAIUserQuery = () => {
  return useStudioIsStudioAiUserQuery(undefined, {
    ...options,
    select: data => data?.studioIsStudioAIUser?.studioAIUser,
  })
}

export async function prefetchIsStudioAiUser() {
  const result = await queryClient.fetchQuery({
    ...studioIsStudioAIUserQueryOptions(),
    ...options,
  })
  return result?.studioIsStudioAIUser?.studioAIUser === true
}
